<template>
  <kaz-notification
    :visibility="true"
    :label="getText.header"
    :description="getText.paragraph"
    :mode="'inline'"
    :closeNeeded="false"
    :appearance="'error'"
    :actionsNeeded="true"
    :mainActionLabel="getText.button"
    :mainAction="actionPro"
    :secondActionLabel="'Вернуться на главную'"
    :secondAction="toMainPage"
  />
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import KazNotification from '@/components/KazUI/molecules/notification'


export default {
  name: 'dialog-limit',
  components: {
    KazNotification
  },
  computed: {
    ...mapGetters({
      sessionActive: 'authData/sessionActive',
    }),
    getText() {
      let header = 'Закончился лимит запросов КазательGPT';
      let paragraph = 'Подожди до завтра или оформи тариф с большим количеством запросов';
      let button = 'Оформить другой тариф';
      if (!this.sessionActive) {
        header = 'Чтобы продолжать чат с КазательGPT нужно войти';
        paragraph = 'Это бесплатно, не переживай';
        button = 'Войти в аккаунт';
      }
      return { header, paragraph, button }
    }
  },
  methods: {
    actionPro() {
      if (this.sessionActive) {
        this.$router.push({ name: 'personal-info' });
      } else {
        this.$router.push({ name: 'login' });
      }
    },
    toMainPage(event) {
      event.preventDefault();
      this.$router.push({ name: 'tasks' })
    }
  }
}
</script>

<style scoped>

@media screen and (max-width: 768px) {
  
}

</style>
